import React from 'react';

interface ValidationError {
  row: number;
  field: string;
  error: string;
}

interface ValidationErrorsProps {
  errors: ValidationError[];
}

const ValidationErrors: React.FC<ValidationErrorsProps> = ({ errors }) => {
  if (errors.length === 0) return null;

  return (
    <div className="s-admin-bulk-upload-errors-section">
      <h3 className="s-admin-bulk-upload-errors-title">Validation Errors</h3>
      <p className="s-admin-bulk-upload-errors-subtitle">Please fix these errors before proceeding</p>

      <table className="s-admin-bulk-upload-errors-table">
        <thead>
          <tr>
            <th>ROW</th>
            <th>FIELD</th>
            <th>ERROR</th>
          </tr>
        </thead>
        <tbody>
          {errors.map((error, index) => (
            <tr key={index}>
              <td>{error.row}</td>
              <td>{error.field}</td>
              <td className="s-admin-bulk-upload-error-text">{error.error}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ValidationErrors;
